import Box from '@mui/material/Box/Box'
import Stack from '@mui/material/Stack/Stack'
import { useMemo } from 'react'

import { LocationServiceTypeClientDto, WaitlistOrderClientDto } from 'service-api/src/types/api'
import { InStayServiceTypes } from './in_stay_service_types'
import { Pets } from './pets'
import { getServiceTypesByPetId, getTrainingVisits } from './pets_and_service_type_helper'
import { ServiceType } from './service_type'
import { VisitDate } from './visit_date'

export const waitlistVisitGridSx = {
  display: 'grid',
  gridTemplateColumns: 'minmax(120px, 1fr) minmax(120px, 1fr) minmax(180px, 1fr)',
  columnGap: 2,
  rowGap: 0.5,
  width: '100%',
} as const

interface Props {
  order: WaitlistOrderClientDto
  serviceTypes: LocationServiceTypeClientDto[]
}

export const PetsAndServiceType = ({ order, serviceTypes }: Props) => {
  const serviceTypesByPetId = useMemo(() => getServiceTypesByPetId(order, serviceTypes), [order, serviceTypes])
  const trainingVisits = useMemo(() => getTrainingVisits(order, serviceTypes), [order, serviceTypes])
  const visits =
    trainingVisits.length > 0
      ? trainingVisits
      : (order.pets?.map((pet) => ({
          invoice: undefined,
          pet,
          primaryOfferDisplayName: pet.id ? serviceTypesByPetId.get(pet.id)?.primaryOfferDisplayName : undefined,
        })) ?? [])

  return (
    <Box sx={waitlistVisitGridSx}>
      {visits.map((visit, index) => {
        const renderAvatar = index === 0
        const petServiceTypes = visit.pet.id ? serviceTypesByPetId.get(visit.pet.id) : undefined

        return (
          <Box key={`${visit.invoice?.id || visit.pet.id || 'pet'}-${index}`} sx={{ display: 'contents' }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{ gridColumn: 1, marginLeft: '4px !important' }}
            >
              <ServiceType order={order} displayName={visit.primaryOfferDisplayName} renderAvatar={renderAvatar} />
              <InStayServiceTypes serviceTypes={petServiceTypes?.inStayServiceTypes ?? []} />
            </Stack>
            <Box sx={{ gridColumn: 2 }}>
              <Pets pet={visit.pet} />
            </Box>
            {visit.invoice && (
              <Box sx={{ gridColumn: 3, alignSelf: 'center' }}>
                <VisitDate order={order} invoice={visit.invoice} />
              </Box>
            )}
          </Box>
        )
      })}
      {trainingVisits.length === 0 && visits.length > 0 && (
        <Box sx={{ gridColumn: 3, gridRow: `1 / span ${visits.length}`, alignSelf: 'center' }}>
          <VisitDate order={order} />
        </Box>
      )}
    </Box>
  )
}
